import api from '../../../services/api';

export const CompaniesHTTP = {
  create: (payload = {}) => api.post('/companies', payload),
  update: (id = '', payload = {}) => api.put(`/companies/${id}`, payload),
  delete: (id = '') => api.delete(`/companies/${id}`),
  reactive: (id = '') => api.delete(`/companies/reactive/${id}`),
};
